import { useState } from "react";

import ProfileItemTitle from "@/components/home/sections/components/ProfileItemTitle";
import ProfileShowMoreButton from "@/components/home/sections/components/ProfileShowMoreButton";

interface IProps {
  title: string | React.ReactNode;
  subTitle: string | React.ReactNode;
  children?: React.ReactNode;
  index: number;
  sectionId: string;
  hasAdditionalInfo: boolean;
  alwaysVisibleChildren?: React.ReactNode;
}

const ProfileSectionRow = ({
  title,
  subTitle,
  children,
  index,
  sectionId,
  hasAdditionalInfo,
  alwaysVisibleChildren,
}: IProps) => {
  const [isExpanded, setIsExpanded] = useState(index === 0 || false);

  return (
    <div>
      <ProfileItemTitle
        title={title}
        subTitle={subTitle}
        sectionId={sectionId}
      />

      {alwaysVisibleChildren && <div className="mt-4 flex flex-row gap-4">{alwaysVisibleChildren}</div>}
      {hasAdditionalInfo && (
        <>
          <div
            className={`mb-4 flex flex-col gap-4 overflow-hidden transition-all duration-300 ${
              !isExpanded ? "max-h-[0px]" : "mt-4 max-h-[1000px]"
            }`}
          >
            {children}
          </div>
          <ProfileShowMoreButton
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
          />
        </>
      )}
    </div>
  );
};

export default ProfileSectionRow;
